import SectionRecord from "models/view-models/section-record";
import TiaRecord from "models/view-models/tia-record";
import EnhancedContentPanel from "organisms/enhanced-content/enhanced-content-panel";
import IndicatorIcons from "organisms/indicator-buttons/indicator-icons";
import React from "react";
import useEnhancedContent from "utilities/hooks/domain/enhanced-content/use-enhanced-content";
import useModalActions from "utilities/hooks/use-modal-actions";
import SectionDetailActions from "./section-detail-actions";
import useLazyLoadEnhancedContent from "utilities/hooks/domain/enhanced-content/use-lazy-load-enhanced-content";

interface SectionDetailContentProps {
    sectionLabel: JSX.Element | undefined;
    cssBaseClass: string;
    handleDiffPanelOpen: () => void;
    handleTiaPanelOpen: (tiaExternalId: string) => void;
    section: SectionRecord;
    tias: TiaRecord[];
    titleClassName: string;
}
const SectionDetailContent = (props: SectionDetailContentProps) => {
    const {
        cssBaseClass,
        sectionLabel,
        handleDiffPanelOpen,
        handleTiaPanelOpen,
        section,
        tias,
        titleClassName,
    } = props;

    const {
        enhancedContentForCurrentCaapsItem,
        enhancedContentResourcesForCurrentCaapsItem,
        currentEnhancedContentManifest,
        getEnhancedContentDetails,
        loadingEnhancedContent,
    } = useEnhancedContent({
        externalId: section.externalId,
    });

    const {
        isOpen: enhancedContentPanelOpen,
        handleOpen: handleEnhancedContentModalOpen,
        handleClose: handleEnhancedContentModalClose,
    } = useModalActions();

    const { getObserverRef } = useLazyLoadEnhancedContent({
        onIntersect: getEnhancedContentDetails,
        isLoading: loadingEnhancedContent,
        hasData: !!enhancedContentForCurrentCaapsItem,
    });

    const showEnhancedContentPanel =
        enhancedContentForCurrentCaapsItem != null ||
        currentEnhancedContentManifest != null;

    return (
        <React.Fragment>
            <span className={titleClassName}>
                <IndicatorIcons
                    tias={tias}
                    changes={section.changes}
                    handleDiffPanelOpen={handleDiffPanelOpen}
                    handleTiaClick={handleTiaPanelOpen}
                />
                <span>
                    {sectionLabel}
                    {section.getTitle()}
                </span>
                <SectionDetailActions
                    resources={enhancedContentResourcesForCurrentCaapsItem}
                    section={section}
                    onEditEnhancedContentClick={handleEnhancedContentModalOpen}
                    onEditEnhancedContentClose={handleEnhancedContentModalClose}
                    showEnhancedContentModal={enhancedContentPanelOpen}
                    handleDiffPanelOpen={handleDiffPanelOpen}
                />
            </span>
            <div className={`${cssBaseClass}__body`}>{section.getBody()}</div>
            {showEnhancedContentPanel && (
                <div className={`${cssBaseClass}__enhanced-content`}>
                    <EnhancedContentPanel
                        enhancedContent={
                            enhancedContentForCurrentCaapsItem ?? undefined
                        }
                        enhancedContentManifest={
                            currentEnhancedContentManifest ?? undefined
                        }
                        getEnhancedContentDetails={getEnhancedContentDetails}
                        onEditClick={handleEnhancedContentModalOpen}
                        resources={enhancedContentResourcesForCurrentCaapsItem}
                        resourcesLoading={false}
                        observerRef={getObserverRef}
                    />
                </div>
            )}
        </React.Fragment>
    );
};

export default SectionDetailContent;
